import {handleActions} from "redux-actions"
import {SET_STATUS,NEXT_PAGE,BACK_PAGE,RESET_PAGE,
        ASSETTYPES_LOADING } from "../actionTypes/assetTypesActions"
var update = require('immutability-helper')

const initialState={
  page:0,
  loading:false
}

const reducer=handleActions({
  [NEXT_PAGE]:(state,action)=>update(state,{page:{$set:state.page+1}}),
  [BACK_PAGE]:(state,action)=>update(state,{page:{$set:state.page-1}}),
  [RESET_PAGE]:(state,action)=>update(state,{page:{$set:initialState.page}}),
  [ASSETTYPES_LOADING]:(state,action)=>update(state,{loading:{$set:action.payload}}),
},initialState)

export default reducer
